import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { getDefaultRouteByPermissions } from 'utils/getDefaultRouteByPermissions';
import { toast } from 'react-toastify';
import Cookies from 'js-cookie';
import { removeStoredPermissions } from './permissionsStorage';

const SafeLoginRedirect = ({ role }) => {
  const navigate = useNavigate();

  useEffect(() => {
    if (!role) return;

    const savedPath = localStorage.getItem('lastVisitedPath');
    const fromLogin = sessionStorage.getItem('FROM_LOGIN') === 'true';
    const r = String(role).toLowerCase();

    // consume flag once
    sessionStorage.removeItem('FROM_LOGIN');

    const safeNavigate = (path) => {
      if (path && path.startsWith('/')) {
        navigate(path, { replace: true });
      }
    };

    // STUDENT
    if (r === 'student') {
      if (fromLogin) {
        navigate('/dashboard/default', { replace: true });
      } else {
        safeNavigate(savedPath);
      }
      return;
    }

    // SUPERADMIN
    if (r === 'superadmin') {
      if (fromLogin) {
        navigate('/supermostadmin/default', { replace: true });
      } else {
        safeNavigate(savedPath);
      }
      return;
    }

    // ADMIN / OTHERS
    if (fromLogin) {
      const def = getDefaultRouteByPermissions();
      if (!def) {
        toast.error('You have no permission to access any module.');
        Cookies.remove('Token');
        Cookies.remove('Role');
        removeStoredPermissions();
        Cookies.remove('_Id');
        Cookies.remove('isPasswordChanged');
        Cookies.remove('user');
        navigate('/login', { replace: true });
        return;
      }
      navigate(def, { replace: true });
      return;
    }

    // reload case
    safeNavigate(savedPath);
  }, [role, navigate]);

  return null;
};

export default SafeLoginRedirect;
